import { render, staticRenderFns } from "./QAndA.vue?vue&type=template&id=fe651728&scoped=true"
import script from "./QAndA.vue?vue&type=script&lang=js"
export * from "./QAndA.vue?vue&type=script&lang=js"
import style0 from "./QAndA.vue?vue&type=style&index=0&id=fe651728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe651728",
  null
  
)

export default component.exports